const map = {
	"./da.json": [
		3753,
		[
			753
		]
	],
	"./en.json": [
		6065,
		[
			65
		]
	],
	"./nb.json": [
		5346,
		[
			346
		]
	],
	"./nn.json": [
		6438,
		[
			438
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2071;
module.exports = webpackAsyncContext;